<template>
    <div v-if="!loadFiles" class="modal fade" :id="`${id}`" tabindex="-1" role="dialog" :aria-labelledby="`${id}Label`" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <i class="ri-file-text-line"></i>
                    <h3 class="modal-body-title">Generar certificados</h3>

                    <VsudSelect 
                    title="Selecciona la plantilla de tu certificado"
                    v-model="template"
                    id="template"
                    name="template"
                    placeholder="Seleccione una plantilla"
                    :items="templates"
                    :showRequired="false"
                    :asterisk="true"
                    :moreInfo="true"
                    :isRequired="true"
                    moreInfoText="Seleccione la plantilla que se utilizara para otorgar el certificado"
                    class="col-12"
                    />
                    <VsudTextarea
                        title="Ingresa una o más patentes (máximo 50)"
                        v-model="plates"
                        id="plates"
                        name="plates"
                        placeholder="Ejemplos válidos: PCKL-49 ,AbCD88 |defg-57|! ..."
                        :isRequired="false"
                        :showRequired="false"
                        :asterisk="true"
                        :moreInfo="true"
                        :disableValidation="true"
                        moreInfoText="Puede ingresar las patentes en el formato que desee, mientras sean válidas."
                    />
                </div>
                <div class="modal-footer col-12 g-2">
                    <button type="button" class="btn btn-secondary" id="close_btn" data-bs-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-primary" :disabled="hasError" @click="handleGenerateCertificates">Generar</button>
                </div>
            </div>
        </div>
    </div>
    <div style="display: none;">
        <component 
            v-if="CertificateMiGps" 
            :is="CertificateMiGps" 
            ref="certificateMiGps"
        />
    </div>
    <VsudLoading v-if="loadFiles" />
</template>
<script>
import Swal from 'sweetalert2';
import VsudSelect from '@/components/VsudSelect.vue';
import VsudLoading from '@/components/VsudLoading.vue';
import VsudTextarea from '@/components/VsudTextarea.vue';
import VsudDropzone from '@/components/VsudDropzone.vue';

export default {
    name: "ModalCertificateCreator",
    inject: ['api_provider', 'urls_server', 'securedWebStorage'],
    components: {
        VsudSelect,
        VsudLoading,
        VsudTextarea,
        VsudDropzone
    },
    props: {
        id: {
            type: String,
            default: ""
        },
    },
    data(){
        return{
            template: null,
            plates: '',
            platesNormalized: [],
            templates: [],
            info_certificates: [],
            loadFiles: false,
            CertificateMiGps: null,
            hasError: false,
        }
    },
    mounted() {
        const modalElement = document.getElementById(this.id);
        modalElement.addEventListener('hidden.bs.modal', this.onModalHidden);
    },
    beforeUnmount() {
        this.loadFiles = false
        const modalElement = document.getElementById(this.id);
        modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden);
    },
    methods: {
        async loadCertificateComponent() {
            if (!this.CertificateMiGps) {
                const module = await import('@/templates/CertificateExample.vue');
                this.CertificateMiGps = module.default;
            }
        },
        async get_selects_options() {
          try {
            const response = await this.api_provider.post(this.urls_server.get_certificates, {}, "get");
            if (response && response.data) {
                this.templates = response.data.templates || []
            }
          } catch (error) {
            console.log("Error get_selects_options: ", error);
          }
        },
        async handleGenerateCertificates() {
            if (!this.validateInputs()) return;
            this.loadFiles = true;
            // Ocultar backdrop manualmente
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) backdrop.remove();
            document.body.classList.remove('modal-open');
            await this.loadCertificateComponent();
            await this.generateCertificates();
            setTimeout(() => {
                this.onModalHidden();
            }, 300);

        },
        validateInputs() {
            if (!this.template) {
                Swal.fire({ icon: 'warning', title: "Por favor, seleccione una plantilla.", showConfirmButton: true });
                return false;
            }
            if (!this.plates || !this.plates.trim()) {
                Swal.fire({ icon: 'warning', title: "Por favor, ingrese patentes.", showConfirmButton: true });
                return false;
            }
            this.platesNormalized = this.normalizeMassivePlatesToArray(this.plates);
            if (this.platesNormalized.length >= 51) {
                Swal.fire({ icon: 'warning', title: "Por favor, asegúrese de ingresar menos de 50 patentes.", showConfirmButton: true });
                return false;
            }
            if (this.platesNormalized.some(plate => plate === "")) {
                Swal.fire({ icon: 'warning', title: "Por favor, asegúrese de que todas las patentes sean válidas.", showConfirmButton: true });
                return false;
            }
            return true;
        },
        normalizeMassivePlatesToArray(rawInput) {
            if (!rawInput) return "";

            // mayúsculas y reemplazo de separadores por espacio
            let cleaned = rawInput.toUpperCase().replace(/[\n,;.\t\s]+/g, " ");

            // acepta AAAA-99 y también AAAA99 (se inserta guion)
            const matches = cleaned.match(/[A-Z]{4}-?\d{2}/g) || [];

            // normaliza a AAAA-99, elimina duplicados y junta con coma
            const normalized = [...new Set(
                matches.map(p => p.replace(/-/g, "").replace(/^([A-Z]{4})(\d{2})$/, "$1-$2"))
            )];

            return normalized
        },
        async generateCertificates() {
            const self = this
            try {
                const postData= {template: self.template, plates: this.platesNormalized};
                const response = await this.api_provider.post(this.urls_server.get_certificates, postData);

                if (response?.data) {
                    self.info_certificates = response.data.info_certificates || [];
                    const issuedCertificates = response.data.issued_certificates || [];
                    const failedPlates = response.data.failed_plates || [];
                    let successMessage = '';

                    if (issuedCertificates.length === 0) {
                        Swal.fire({icon: 'warning', title: "No se encontraron dispositivos, asegúrese de que todas las patentes sean válidas.", showConfirmButton: true });
                    } else {
                        if (issuedCertificates.length === 1) {
                            for (const issued of issuedCertificates) {
                                const plate = issued.plate;
                                const info = self.info_certificates[plate] || {};
                                const template = response.data.template;
                                await self.downloadCertificates(template, plate, info, issued);
                            }
                        } else {
                            const dataList = issuedCertificates.map(issued => {
                                const plate = issued.plate;
                                const info = self.info_certificates[plate] || {};
                                const template = response.data.template;

                                return { template, plate, info, issued };
                            });
                            await this.$refs.certificateMiGps.downloadAllPDFs(dataList);
                        }

                        if (issuedCertificates.length > 0) { successMessage += `Se han generado ${issuedCertificates.length} certificados con éxito.\n`; }
                        if (failedPlates.length > 0) { successMessage += `No se encontraron las siguientes patentes: \n${failedPlates.join(', ')}.\n`; }

                        Swal.fire({
                            icon: 'success',
                            title: successMessage,
                            showConfirmButton: true,
                            width: '800px'
                        });
                    }
                }
            } catch (error) {
                Swal.fire({icon: 'warning', title: "Ocurrió un error al procesar la solicitud. Intente nuevamente más tarde.", showConfirmButton: true });
                console.log("Error generateCertificates: ", error);
            } finally {
                this.loadFiles = false;
            }
        },
        async downloadCertificates(template, plate, info, issued) {
            // console.log("downloadCertificates")
            if(template && template.template_format == 1){
                await this.$refs.certificateMiGps.downloadPDF(template, plate, info, issued);
            }
        },
        clearModal(){
            this.template = null
            this.plates= ""
        },
        onModalHidden() {
            this.$emit('modal-closed');
            this.clearModal()
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) backdrop.remove();
            document.body.classList.remove('modal-open');
        }
    }
};
</script>

<style scoped>
.btn-close {
    filter: invert(1);
}

button.btn {
    font-weight: 400;
    text-transform: none;
    font-size: 1rem;
}
.btn-secondary, .btn-primary{
    width: calc(50% - 8px);
}
.ri-file-text-line{
    color: var(--blue);
    font-size: 45px;
}
.modal-body-title{
    color: var(--blue);
    margin-bottom: 1.2rem;
}
.modal-header{
    border-bottom: 0px;
    padding-bottom: 0;
}
.modal-body{
    padding-top: 0;
    padding: 0 2rem 1rem;
}
.modal-footer {
    padding: 0 2rem 1rem;
    border-top: 0;
}

.modal-dialog {
    min-width: 530px; /* 720px; */
}
#plates_cont{
    padding-bottom: 0 !important;
}
</style>